// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"number-module--wrapper--3AZUb","number":"number-module--number--28TzP","slash":"number-module--slash--2LDlB"};